import { render, staticRenderFns } from "./CrowdfundingGuideView.vue?vue&type=template&id=151a8ea8"
import script from "./CrowdfundingGuideView.vue?vue&type=script&lang=js"
export * from "./CrowdfundingGuideView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports